import ImageInlineIcon from '@atlaskit/icon/core/image-inline';
import * as React from 'react';

export const SvgImageInline = () => (
  <ImageInlineIcon label="" testId="ads-refreshed-icon" />
);
